import SimpleLightbox from 'simplelightbox';

export class Media {
  constructor() {
    document.querySelectorAll('.s-media__gallery').forEach((gallery) => {
      new SimpleLightbox(gallery.querySelectorAll('.s-media__item'), {
        captionsData: 'data-alt',
        captionDelay: 250,
        nav: true,
        showCounter: true,
      });
    });

    document.querySelectorAll('.s-media__video').forEach((wrapper) => {
      const video = wrapper.querySelector('.s-media__player');
      const trigger = wrapper.querySelector('.s-media__trigger');
      if (!video || !trigger) return;

      trigger.addEventListener('click', () => {
        wrapper.classList.add('is-playing');
        video.controls = true;
        video.play();
      });
    });
  }
}
